export enum ExtraHolidayType {
    COIN = 'COIN',
    PATERNITY = 'PATERNITY',
    OTHER = 'OTHER',
    REGULAR = 'REGULAR',
}
